import { DownloadNSendEmailReportActions } from "@frameworks/web/redux/actions/Reports/CoreReports/DownloadNSendEmailReportActions";
export default () => ({
    downloadReportActions: new DownloadNSendEmailReportActions(),
});
